import store from '@custom/shared/store/store.js';

// 로그인 화면(/)으로 보낼 주소. 로그인 후 원래 위치로 돌아오도록 redirect 를 붙인다.
// reason 을 주면 로그인 화면이 그 사유를 화면 안에 안내한다(Login.vue — 'session').
export function loginUrlWithRedirect(reason) {
    const here = window.location.pathname + window.location.search + window.location.hash;
    const query = [];
    if (window.location.pathname !== '/') query.push(`redirect=${encodeURIComponent(here)}`);
    if (reason) query.push(`reason=${reason}`);
    return query.length ? `/?${query.join('&')}` : '/';
}

// 다른 탭의 localStorage 변경이 이 탭의 로그인에 주는 영향 (App.vue storage 리스너).
// 'logout' = 로그아웃·초기화, 'switch' = 다른 계정으로 바뀜, null = 무관.
// tabUserId 는 이 탭이 알고 있는 계정(store.user_id) — 이 탭이 로그아웃 이동을 취소해 남아 있다가
// 다른 탭이 새 계정으로 로그인하는 경우(oldValue 가 비어 있음)도 잡는다.
// 같은 계정의 토큰 갱신(tokenRefresh.js)은 accessToken 값만 바뀌므로 null 이다.
export function sessionChangeOf({key, oldValue, newValue}, tabUserId) {
    if (key === null || (key === 'accessToken' && !newValue)) return 'logout';
    if (key === 'user_id' && newValue && tabUserId && String(newValue) !== String(tabUserId)) return 'switch';
    if (['user_id', 'company_id'].includes(key) && oldValue && newValue && oldValue !== newValue) return 'switch';
    return null;
}

// 다른 탭에서 계정이 바뀐 뒤 이 탭(이전 계정 화면)의 쓰기 요청이 새 계정 토큰으로 나가는지 (요청 인터셉터 안전망).
// 조회(GET·HEAD·OPTIONS)와 로그인·토큰 갱신·로그아웃 요청, 이 탭 계정을 모르는 경우(store.user_id 빈 값)는 통과.
export function isAccountChangedElsewhere(config) {
    const method = String((config && config.method) || 'get').toLowerCase();
    if (['get', 'head', 'options'].includes(method)) return false;
    const url = String((config && config.url) || '');
    if (/\/(login|logout)(\?|$)|\/clients\/login|\/v2\/auth\/refresh/.test(url)) return false;
    const tabUserId = store.state.user_id;
    const nowUserId = localStorage.getItem('user_id');
    return !!tabUserId && !!nowUserId && String(tabUserId) !== String(nowUserId);
}

let _inflight = null; // 로그아웃 POST 진행 중 — 이 동안의 중복 호출은 같은 Promise 로 합친다
let _leaving = false; // 로그인 화면으로 replace 한 직후

function leaveTo(url) {
    _leaving = true;
    window.location.replace(url);
    // 미저장 확인창에서 '머무르기'를 고르면 이 페이지가 남는다 — 1초 뒤 풀어 다음 401 에서 다시 이동한다
    setTimeout(() => { _leaving = false; }, 1000);
}

// 세션 만료(401) 공통 처리: 로그아웃 후 /?redirect=<현재 주소>&reason=session 으로 보낸다.
// 인터셉터·화면 catch 의 중복 호출은 한 번으로 합치고, 이동이 취소된 뒤의 401 은 POST 없이 이동만 다시 한다.
function commonLogout() {
    if (_inflight) return _inflight;
    if (_leaving) return Promise.resolve();
    const _login_url = loginUrlWithRedirect('session');
    if (!localStorage.getItem('accessToken')) {
        leaveTo(_login_url);
        return Promise.resolve();
    }
    _inflight = store.dispatch('logout').finally(() => {
        _inflight = null;
        leaveTo(_login_url);
    });
    return _inflight;
}

export default commonLogout;
